import { render, staticRenderFns } from "./CurrencyView.vue?vue&type=template&id=2998acfa&scoped=true"
import script from "./CurrencyView.vue?vue&type=script&lang=js"
export * from "./CurrencyView.vue?vue&type=script&lang=js"
import style0 from "./CurrencyView.vue?vue&type=style&index=0&id=2998acfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998acfa",
  null
  
)

export default component.exports